<div class="wrapper" *ngIf="serviceTicketStore.assistantArticlesSummary$ | async as articles">
  <ng-container *ngIf="articles.length > 0">
    <div class="content-wrapper">
      <div *ngFor="let article of articles" class="content-article">
        <div class="article-inner-wrapper">
          <div class="article-icon"><mat-icon>description</mat-icon></div>
          <div
            class="article-description"
            [innerHTML]="article?.title | stripHtml: [stripHtmlParams.Concept]"
          ></div>
        </div>
        <div class="article-options" (click)="navigateToArticle(article)">
          <mat-icon>arrow_forward</mat-icon> {{ 'SERVICE_TICKET.READ_MORE' | translate }}
        </div>
      </div>
    </div>
  </ng-container>

  <app-banner type="info" *ngIf="articles.length === 0">
    {{ '+SERVICE_TICKET.NO_ARTICLES_FOUND' | translate }}
  </app-banner>
</div>
